import { clearCache } from './offlineCache/db';

// Encerra a sessão: limpa o sessionStorage (token, roles, dentistIdFromUser,
// userEmail, etc.) e apaga o cache de leitura offline (IndexedDB), para que
// dados de paciente não fiquem no dispositivo após o logout — importante em
// máquina compartilhada de clínica.
// A limpeza do cache é best-effort e assíncrona; o chamador pode navegar em
// seguida sem esperar.
export function logout() {
  sessionStorage.clear();
  return clearCache().catch(() => {
    /* limpeza do cache é best-effort; falha não deve travar o logout */
  });
}
